/* eslint-disable import/prefer-default-export */
import { makeVar } from '@apollo/client';
import { getLocalStorageVariable } from '../helpers/local-storage';

export const selectedCompanyRut = makeVar(
  getLocalStorageVariable('selectedCompanyRut') || null,
);

export const cessionRequestingPlatformCodeOverrideVar = makeVar(null);
